// import {documentTool,fontInfo,tableInfo } from './const'
export default {
    state: {
        name: "", // string
        priority: 0, // number
        schedule: 0, // number
        landmark: false, // boolean
        startDate: "", // string
        endDate: "", // string
        timeLimit: 0, // number
        RowHeight: 0, // number
        isIndent: false, // boolean
        isOutdent: false, // boolean
        isNull: false, // boolean
        isMultiSel: false, // boolean
        canLink: false, // boolean
        canUnlink: false, // boolean
        optionObj: {}, // object
        DelayTasks: false, // boolean
        CriticalPath: false, // boolean
        isExpandAllTask: false, //boolean
        isHideAllTask: false,
        canMoveUpTasks: false,
        canMoveDownTasks: false,
        canAddLeftLabel: false,
        canAddRightLabel: false,
        selectAll: false,
        selectTask: false,
        selectGanttColumnName: false,
        customTextColumnNum: 1, // number
        activeThemeID: 0,
        isShowTodayLine: false,
        canMoveColumnToLeft: false,
        canMoveColumnToRight: false,

        expandList: ["task", "navigation", "option", "theme"],
    },
    mutations: {
        initGantt(state, object) {
            state.name = object.name || "";
            state.priority = object.priority || 0;
            state.schedule = object.schedule || 0;
            state.landmark = object.landmark || false;
            state.startDate = object.startDate || "";
            state.endDate = object.endDate || "";
            state.timeLimit = object.timeLimit || 0;
            state.RowHeight = object.RowHeight || 25;
            state.isIndent = object.isIndent;
            state.isOutdent = object.isOutdent;
            state.isNull = object.isNull;
            state.isMultiSel = object.isMultiSel;
            state.canLink = object.canLink;
            state.canUnlink = object.canUnlink;
            state.optionObj = object.optionObj;
            state.DelayTasks = object.DelayTasks;
            state.CriticalPath = object.CriticalPath;
            state.isExpandAllTask = object.isExpandAllTask;
            state.isHideAllTask = object.isHideAllTask;
            state.canMoveUpTasks = object.canMoveUpTasks;
            state.canMoveDownTasks = object.canMoveDownTasks;
            state.canAddLeftLabel = object.canAddLeftLabel;
            state.canAddRightLabel = object.canAddRightLabel;
            state.SelectAll = object.selectAll;
            state.selectTask = object.selectTask;
            state.selectGanttColumnName = object.selectGanttColumnName;
            state.customTextColumnNum = object.customTextColumnNum;
            state.activeThemeID = object.activeThemeID;
            state.isShowTodayLine = object.isShowTodayLine;
            state.canMoveColumnToLeft = object.canMoveColumnToLeft;
            state.canMoveColumnToRight = object.canMoveColumnToRight;
        },
        setGanttState(state, obj) {
            state[obj.type] = obj.data;
        },
        setGantt(state, object) {
            switch (object.name) {
                case "name": {
                    state.name = object.data;
                    break;
                }
                case "priority": {
                    state.priority = object.data;
                    break;
                }
                case "schedule": {
                    state.schedule = object.data;
                    break;
                }
                case "landmark": {
                    state.landmark = object.data;
                    break;
                }
                case "startDate": {
                    state.startDate = object.data;
                    break;
                }
                case "endDate": {
                    state.endDate = object.data;
                    break;
                }
                case "timeLimit": {
                    state.timeLimit = object.data;
                    break;
                }
                case "RowHeight": {
                    state.RowHeight = object.data;
                    break;
                }
                case "customTextColumnNum": {
                    state.customTextColumnNum = object.data;
                    break;
                }
                case "activeThemeID": {
                    state.activeThemeID = object.data;
                    break;
                }
            }
        },
        // getGantts(state,str){
        //     let target = '';
        //     switch(str){
        //         case 'TaskName': {
        //             target = state.name
        //             break
        //         }
        //         case 'Priority': {
        //             target = state.priority
        //             break
        //         }
        //         case 'Percent': {
        //             target = state.schedule.substring(0,state.schedule.length-1)
        //             break
        //         }
        //         case 'Milestone': {
        //             target = state.landmark
        //             break
        //         }
        //         case 'StartTime': {
        //             target = state.startDate
        //             break
        //         }
        //         case 'FinishTime': {
        //             target = state.endDate
        //             break
        //         }
        //         case 'Duration': {
        //             target = state.timeLimit.substring(0,state.timeLimit.length-1)
        //             break
        //         }
        //         default: {
        //             return 'wrong str'
        //         }
        //     }
        //     return target;
        // }
    },
};
